import axios from "axios";


const requestData = async (action, params) => {

    let BaseUrl = `https://www.vigler.com`
    
    try {
        const appId = 1;
        let token = '';
        
        token = '';
        if (action !== 'BOSignIn' && action !== 'SignUp') {
            token = localStorage.getItem("auth-token"); 
        }

        const now = new Date();
        const offsetMs = now.getTimezoneOffset() * 60000;
        const createAt = new Date(now - offsetMs).toISOString().slice(0, 19).replace('T', ' ');

                
        
        params = { ...params };

        const response = await axios.post(`${BaseUrl}/api/ver1/run`,            
            { action, params },
            { headers: { token, appId, createAt } }
        );

        return response.data;
    } catch (error) {
        console.error("Error in axiosRequest:", error);
        throw error;
    }
};



// מעלה קובץ (base64) ל-/api/file/upload — אותו endpoint שהאפליקציה משתמשת בו
// להעלאת תמונות סטורי ממכשיר (ראו AddStoryModal.tsx ו-saveBase64Image.ts).
// userId קבוע כי בבק אופיס אין מזהה משתמש מספרי — הוא משמש רק לשם הקובץ.
const uploadFile = async (base64Data, folder, fileExt) => {
    let BaseUrl = `https://www.vigler.com`;

    try {
        const response = await axios.post(`${BaseUrl}/api/file/upload`, {
            userId: 1,
            base64Data,
            folder,
            fileExt,
        });
        return response.data;
    } catch (error) {
        console.error("Error uploading file:", error);
        throw error;
    }
};

export default { requestData, uploadFile };
